import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Spinner } from '../common/Spinner';

interface Props {
  requiredPermission?: string;
  children?: React.ReactNode;
}

export function ProtectedRoute({ requiredPermission, children }: Props) {
  const { isAuthenticated, isLoading, hasPermission } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spinner size="lg" label="Checking your session…" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Carry the attempted destination so sign-in returns the user there
    // rather than always dumping them on the dashboard.
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    return (
      <Navigate
        to="/"
        replace
        state={{ message: 'You do not have permission to view that page.' }}
      />
    );
  }

  return children ? <>{children}</> : <Outlet />;
}
